(() => {
  const root = document.querySelector('.volt-pdp');
  if (!root) return;

  const stage = root.querySelector('[data-volt-gallery-stage]');
  const thumbs = root.querySelectorAll('[data-volt-gallery-thumb]');
  if (stage && thumbs.length) {
    const imgs = stage.querySelectorAll('.volt-pdp__stage-img');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.getAttribute('data-media-id');
        thumbs.forEach((t) => t.classList.toggle('on', t === thumb));
        imgs.forEach((img) => {
          img.classList.toggle('on', img.getAttribute('data-media-id') === id);
        });
      });
    });
  }

  const qtyInput = root.querySelector('[data-volt-qty-input]');
  root.querySelectorAll('[data-volt-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const delta = Number(btn.getAttribute('data-volt-qty') || 0);
      const next = Math.max(1, (Number(qtyInput.value) || 1) + delta);
      qtyInput.value = String(next);
    });
  });

  // Team-store deep links: ?store=…&page_handle=… → breadcrumb back to that page
  try {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('page_handle');
    const store = params.get('store');
    const storeName = store ? decodeURIComponent(store).replace(/\+/g, ' ') : '';
    const storeHandle = handle || storeName.trim().toLowerCase().replace(/\s+/g, '-');
    const crumbs = root.querySelector('.volt-pdp__crumbs');
    const teamLink = crumbs && crumbs.querySelector('[data-volt-crumb-team]');
    if (storeHandle && teamLink) {
      teamLink.href = `/pages/${encodeURIComponent(storeHandle)}`;
      if (storeName) teamLink.textContent = storeName;
    }
    if (crumbs && crumbs.classList.contains('volt-pdp__crumbs--direct') && storeHandle) {
      crumbs.classList.add('is-store');
    }

    // Soft closed-store notice when arriving from a team store whose deadline has passed
    if (root.getAttribute('data-volt-team-buyable') === 'true' && handle) {
      fetch(`/pages/${encodeURIComponent(handle)}`)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const storeRoot = doc.querySelector('[data-volt-team-store]');
          const deadlineRaw = storeRoot && storeRoot.getAttribute('data-deadline');
          if (!deadlineRaw) return;
          const end = new Date(deadlineRaw).getTime();
          if (isNaN(end) || Date.now() <= end) return;

          root.classList.add('volt-pdp--store-closed');
          const tax = root.querySelector('.volt-pdp__tax');
          if (tax) {
            tax.classList.add('volt-pdp__tax--closed');
            tax.textContent = 'This team store is closed · Ordering is no longer available';
          }
          const atc = root.querySelector('.volt-pdp__atc');
          if (atc && !atc.disabled) {
            atc.disabled = true;
            atc.setAttribute('aria-disabled', 'true');
            const label = atc.querySelector('span');
            if (label) label.textContent = 'Store Closed';
          }
          const idInput = root.querySelector('input[name="id"]');
          if (idInput) idInput.disabled = true;
        })
        .catch(() => {});
    }
  } catch (e) {
    /* ignore */
  }
})();
